import { soldaterboegenScene } from './soldaterboegen';
import { raadhustorvetScene } from './raadhustorvet';
import type { AdventureSceneDefinition } from '../../domain/types';

export const adventureScenes: Record<string, AdventureSceneDefinition> = {
  [soldaterboegenScene.id]: soldaterboegenScene,
  [raadhustorvetScene.id]: raadhustorvetScene,
};
